import Modalheader from "../../../components/header";
import React, {useEffect, useState} from "react";
import ModalFooter from "../../../components/footer";
import Button from "../../../../button";
import Banner from "../../../../banner/banner";
import ModalBody from "../../../components/body";
import useModal from "../../../useModal";
import UseContext from "../../../../../hooks/useContext";
import ApiDatabase from "../../../../../server";
import {toast} from "react-toastify";
import {COMPANY_ADMIN_ROLE} from "constants/companyRoles";

const ModalDelCompanyMember = () => {
  const {toggle} = useModal();
  const {modalData, setModalDataReturn, language} = UseContext()
  const token = localStorage.getItem("xsrfToken");
  const [isWaiting, setIsWaiting] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [employee, setEmployee] = useState({})

  useEffect(() => {
    // An entry whose account is gone has nobody to read: the api would answer 404.
    if (modalData.missingAccount) return
    if (modalData.idCompany && modalData.idEmployee) {
      setIsWaiting(true)
      ApiDatabase.getCompanyEmployee({token, idCompany: modalData.idCompany, idEmployee: modalData.idEmployee}, (data) => {
        if (data.employee?.firstname && data.employee?.lastname && data.employee?.email && data.employee?.role) {
          setEmployee({
            firstname: data.employee?.firstname,
            lastname: data.employee?.lastname,
            role: data.employee?.role,
          })
        }
        setIsWaiting(false)
      }, (err) => {
        setIsWaiting(false)
      })
    }
  }, [modalData]);

  const handleSubmit = () => {
    if (modalData.idCompany && modalData.idEmployee) {
      setIsLoading(true)
      ApiDatabase.postDelCompanyMember({token, idCompany: modalData.idCompany, idEmployee: modalData.idEmployee}, (data) => {
        toast.success('Le membre a bien été retiré de l\'entreprise.')
        setModalDataReturn({type: 'employee_deleted', idEmployee: modalData.idEmployee})
        toggle()
        setIsLoading(false)
      }, (err) => {
        toast.error('Une erreur est survenue, veuillez réessayer ou contacter le support');
        setIsLoading(false)
      })
    }
  }

  return (
    <>
      <Modalheader hide={toggle} hideShow={true} icon="warning">
        Exclure un membre
      </Modalheader>
      <ModalBody>
        <div className={'text-sm text-gray-500'}>
          {modalData.missingAccount ? (
            language.getValue('companyContacts.removal.missingAccountConfirm', '')
          ) : isWaiting ? (
            <div>
              <div className={'h-4 skeleton-bar w-full'}></div>
            </div>
          ) : `Êtes-vous sûr de vouloir exclure ${employee.firstname} ${employee.lastname} de votre équipe ?`}
        </div>
        {/* Only the last administrator: the members list sets hasOtherAdmin when another one remains. */}
        {!modalData.missingAccount && Number(employee.role) === COMPANY_ADMIN_ROLE && !modalData.hasOtherAdmin ? (
          <div className={'pt-3'}>
            <Banner type={'warning'}>
              {language.getValue('companyContacts.removal.lastAdminWarning', '')}
            </Banner>
          </div>
        ) : null}
      </ModalBody>
      <ModalFooter>
        {isLoading ? (
          <>
            <Button size={'LG'} color={'SECONDARY'}>Fermer</Button>
            <Button size={'LG'} color={'DISABLED'}>Confirmation ...</Button>
          </>
        ) : (
          <>
            <Button size={'LG'} color={'SECONDARY'} onClick={toggle}>Fermer</Button>
            <Button size={'LG'} color={'PRIMARY'} onClick={handleSubmit}>Confirmer</Button>
          </>
        )}
      </ModalFooter>
    </>
  )
}

export default ModalDelCompanyMember;